import { FormType } from '../../shared/models/form';
import { getLanguage, getSearchFormData } from './utils';

export const submitHandler = (form: FormType) => {
  const searchData = getSearchFormData(form, getLanguage());

  void (async () => {
    const response = await fetch('api/redirect', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(searchData),
    });

    if (!response.ok) {
      window.location.reload();
      return;
    }

    const data = (await response.json()) as
      | { success: true; url: string }
      | { success: false; message: string };

    if (data.success) {
      if (window !== window.parent) {
        window.parent.postMessage({ type: 'redirect', value: data.url }, '*');
      } else {
        window.location.href = data.url;
      }
    }
  })();
};
